import Modal from "../common/Modal";

const COPY_BY_REASON = {
  default: {
    title: "Ready to analyze your own data?",
    body: "Create a free account to upload Excel or CSV files, save your analyses, export reports, and access the full InsightPulse experience.",
  },
  "question-limit": {
    title: "You've explored InsightPulse with demo data",
    body: "Create a free account to analyze your own data and continue asking questions.",
  },
  upload: {
    title: "Ready to analyze your own data?",
    body: "Create a free account to upload your own Excel or CSV files and start a real analysis.",
  },
  export: {
    title: "Exports are for account holders",
    body: "Create a free account to export charts, conversations, and full reports.",
  },
  report: {
    title: "Reports are for account holders",
    body: "Create a free account to generate AI-written sales analysis reports and executive summaries.",
  },
  save: {
    title: "Save your work with a free account",
    body: "Create a free account to save this analysis and come back to it anytime.",
  },
};

// Polished, in-app replacement for a browser alert/confirm — shown whenever
// a demo visitor hits a restricted action (upload, export, save, report,
// or their one included AI question).
export default function UpgradeModal({ open, onClose, onSignUp, reason = "default" }) {
  const copy = COPY_BY_REASON[reason] || COPY_BY_REASON.default;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={copy.title}
      footer={
        <>
          <button
            onClick={onClose}
            className="px-4 py-2.5 rounded-xl bg-gray-800 hover:bg-gray-700 border border-gray-700 transition text-sm font-medium"
          >
            Continue Exploring
          </button>

          <button
            onClick={onSignUp}
            className="px-4 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 transition text-sm font-semibold shadow-lg shadow-blue-900/30"
          >
            Create Free Account
          </button>
        </>
      }
    >
      <p>{copy.body}</p>
    </Modal>
  );
}
